<div class="multiS">
    <ng-multiselect-dropdown [placeholder]="'Selecciona canal:'" [settings]="dropdownSettings" [data]="ltsChannelGet" [(ngModel)]="selectedItems" (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeselect($event)">
    </ng-multiselect-dropdown>
</div>